import { __assign } from "tslib";
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
import { renderAndMountComponent } from '@wix/answers-lib';
import * as React from 'react';
import { Toggle } from './toggle';
export var createLegacyToggleDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, '.toggle', 'Toggle');
    var isOn = function () { return baseDriver.elem.classList.contains('on'); };
    var isDisabled = function () { return baseDriver.elem.classList.contains('disabled'); };
    return {
        isOn: isOn,
        isOff: function () {
            return !isOn();
        },
        toggle: function () {
            return baseDriver.click();
        },
        isDisabled: isDisabled,
    };
};
export var createLegacyToggle = function (props) {
    var elem = renderAndMountComponent(React.createElement(Toggle, __assign({}, props)));
    return createLegacyToggleDriver(elem);
};
//# sourceMappingURL=toggle.legacy-driver.js.map